import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import Stack from '@mui/material/Stack';
import { Autocomplete, TextField } from '@mui/material';
import dayjs from 'dayjs';
import { croPerfomanceAnalyticsTableHeader } from './utils/croPerfomanceAnalyticsTableHeader';
import { getCroPerfomanceAnalytics } from '../../../../redux/features/crdMigrationSlice';
import { getCourses } from '../../../../redux/features/crmSlice';
import GlobalTable from '../../../../components/CustomTableWithPagination/GlobalTable';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import FromAndToDatePicker from '../../../../components/mui/FromAndToDatePicker';

export default function CroPerfomanceAnalytics() {
  // normal variable
  const dispatch = useDispatch();

  // Redux State-------------------------------------------------------------
  //
  const loading = useSelector((state) => state.crdMigration.croPerfomanceAnalyticsTable.loading);
  const croPerfomanceAnalyticsTable = useSelector((state) => state.crdMigration.croPerfomanceAnalyticsTable.data);
  const meta = useSelector((state) => state.crdMigration.croPerfomanceAnalyticsTable.meta);
  const coursesPreData = useSelector((state) => state.crm.coursesPreData);
  const courseLoading = useSelector((state) => state.crm.loading);
  //
  //--------------------------------------------------------------------------

  // react state
  const [fromDate, setFromDate] = useState(dayjs().startOf('year').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(dayjs().endOf('year').format('YYYY-MM-DD'));
  const [course, setCourse] = useState({ courseId: '', courseName: '' });
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
  });

  // EXCEPT CRO ---------------------------------------------
  useEffect(() => {
    dispatch(getCourses());
  }, [dispatch]);
  // ---------------------------------------------------------

  //---------- DispatchParams ---------------------------------
  const dispatchParams = useMemo(
    () => ({
      fromDate,
      toDate,
      page: tableState?.page,
      limit: tableState?.pageSize,
      search: tableState?.search,
      course: course?.courseId,
    }),
    [fromDate, toDate, tableState, course],
  );

  //---------* =-=-=-==-=--=-=-=-=- *---------------------------

  //-------------- Table Fetch ------------------------------
  useEffect(() => {
    dispatch(getCroPerfomanceAnalytics(dispatchParams)).then((res) => console.log({ res }));
  }, [dispatchParams, dispatch]);
  //-------------* Table Fetch *-----------------------------

  return (
    <GlobalWrapper title={'CRO Perfomance Analytics'}>
      <Stack gap={2}>
        <Stack direction={{ xs: 'column', sm: 'row' }} gap={1}>
          <FromAndToDatePicker fromDate={fromDate} setFromDate={setFromDate} toDate={toDate} setToDate={setToDate} />

          <Autocomplete
            id="combo-box-demo"
            getOptionLabel={({ courseName }) => courseName ?? ''}
            isOptionEqualToValue={(opt, val) => opt?.courseId === val?.courseId}
            options={coursesPreData ?? []}
            onChange={(_, v) => setCourse(v)}
            sx={{ minWidth: 300 }}
            renderInput={(params) => <TextField {...params} label="Course" />}
            loading={courseLoading}
          />
        </Stack>
        <GlobalTable
          headers={croPerfomanceAnalyticsTableHeader}
          tableState={tableState}
          setTableState={setTableState}
          loading={loading}
          rows={[]}
          meta={meta}
        />
      </Stack>
    </GlobalWrapper>
  );
}
